export default {
    internalEvaluation: 'Intern',
    publicEvaluation: 'Link'
}
